if ($('.id--9').length) {
    document.addEventListener("ShoptetDOMContentLoaded", function () {
        mhShippingPrice();
    })
    $(document).ready(function () {
        mhShippingPrice();
    })
}

function mhShippingPrice() {
    var customer = getShoptetDataLayer('customer');
    var cartInfo = getShoptetDataLayer('cartInfo');
    if (!customer || !cartInfo) {
        return;
    }
    var groupId = Number(customer.groupId);
    var priceListId = Number(customer.priceListId);
    var cartPrice = Number(cartInfo.getNoBillingShippingPrice.withoutVat);
    if (groupId !== 2) {
        return;
    }
    if (minimalPriceDisable.includes(priceListId)) {
        return;
    }
    if (cartPrice < minimalPrice) {
        var missingPrice = minimalPrice - cartPrice;
        $('.next-step').addClass('notPossible');
        $('.step.step-2').addClass('notPossible');
        $('.next-step').before(`
            <div class="minimalOrderMessage">
                Minimální hodnota objednávky pro VO je <strong>${Number(minimalPrice).ShoptetFormatAsCurrency()}</strong> bez DPH.<br>
                Do minimální objednávky vám zbývá <strong>${Number(missingPrice).ShoptetFormatAsCurrency()}</strong>.
            </div>
        `);
    }
}



if ($('.id--16').length) {
    document.addEventListener("ShoptetDOMContentLoaded", applyPersonalCollectionOnlyShipping);
    $(document).ready(function () {
        applyPersonalCollectionOnlyShipping();
    })
}

function applyPersonalCollectionOnlyShipping() {
    var customer = getShoptetDataLayer('customer');

    if (!customer || Number(customer.groupId) === 2) {
        return;
    }

    var cartCodes = [];
    $('.cart-items .cart-item[data-micro="cartItem"]').each(function () {
        var code = $.trim($(this).attr('data-micro-sku') || '');
        if (code) {
            cartCodes.push(code);
        }
    });

    var hasPersonalCollectionOnlyProduct = (window.losicaProducts || []).some(function (product) {
        return cartCodes.includes(String(product.code)) && product.productNumber === 'ANO';
    });

    if (!hasPersonalCollectionOnlyProduct) {
        return;
    }

    var $shippingMethods = $('#order-shipping-methods');
    var $personalCollection = $shippingMethods.find('input[data-code="personal-collection"]');

    $shippingMethods.find('.radio-wrapper').not($personalCollection.closest('.radio-wrapper')).remove();

    if (!$personalCollection.prop('checked')) {
        $personalCollection.prop('checked', true).trigger('change').trigger('click');
    }
}